import { useContext } from 'react';
import { DetailsBookingContext } from 'components/DetailsBookingProvider';

export const useDetailsBooking = () => {
  const { data, refetch } = useContext(DetailsBookingContext);

  if (!data || !data.booking) {
    throw new Error('useDetailsBooking() can only be used under <DetailsBookingProvider />');
  }

  return { booking: data.booking, refetch };
};
